const ELEMENT_NAME = 'cart-gift-wrap';

if (!customElements.get(ELEMENT_NAME)) {
  customElements.define(
    ELEMENT_NAME,
    class CartGiftWrap extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('[data-gift-wrap-toggle]');
        this.note = this.querySelector('[data-gift-wrap-note]');
        this.noteWrap = this.querySelector('[data-gift-wrap-note-wrap]');
        this.error = this.querySelector('[data-gift-wrap-error]');

        this.toggle?.addEventListener('change', this.onToggle);
        this.note?.addEventListener('input', this.onNoteInput);
      }

      disconnectedCallback() {
        this.toggle?.removeEventListener('change', this.onToggle);
        this.note?.removeEventListener('input', this.onNoteInput);

        clearTimeout(this.noteTimer);
      }

      onToggle = async (event) => {
        const checkbox = event.currentTarget;
        const shouldEnable = checkbox.checked;

        this.clearError();
        this.setBusy(true);

        try {
          /*
           * ATTIVAZIONE PACCO REGALO
           */
          if (shouldEnable) {
            if (!window.Shopify?.actions) {
              throw new Error(
                'Impossibile aggiornare il carrello. Riprova.'
              );
            }

            const result = await Shopify.actions.updateCart(
              {
                lines: [
                  {
                    merchandiseId: this.dataset.variantGid,
                    quantity: 1,
                  },
                ],
              },
              {
                context: 'cart',
                detail: {
                  source: 'gift-wrap',
                },
              }
            );

            this.throwIfUserError(result);

            return;
          }

          /*
           * DISATTIVAZIONE PACCO REGALO
           */

          const line = Number(this.dataset.line);

          if (!Number.isInteger(line) || line < 1) {
            throw new Error(
              'Riga del pacco regalo non trovata. Riapri il carrello e riprova.'
            );
          }

          const cartItems = this.closest('cart-items-component');

          if (
            !cartItems ||
            typeof cartItems.updateQuantity !== 'function'
          ) {
            throw new Error(
              'Componente carrello Horizon non disponibile.'
            );
          }

          /*
           * Prima cancelliamo l'eventuale nota regalo.
           */
          await this.clearCartNote();

          /*
           * Poi usiamo IL METODO NATIVO DI HORIZON
           * per eliminare la riga dal carrello.
           */
          await cartItems.updateQuantity({
            line,
            quantity: 0,
            action: 'clear',
          });
        } catch (error) {
          /*
           * Se qualcosa fallisce, ripristiniamo
           * visivamente lo stato precedente.
           */
          checkbox.checked = !shouldEnable;

          this.showError(
            error instanceof Error
              ? error.message
              : 'Impossibile aggiornare il carrello. Riprova.'
          );
        } finally {
          this.setBusy(false);
        }
      };

      onNoteInput = () => {
        clearTimeout(this.noteTimer);

        this.noteTimer = setTimeout(() => {
          this.saveNote();
        }, 500);
      };

      async saveNote() {
        if (!this.note || !window.Shopify?.actions) {
          return;
        }

        try {
          const result = await Shopify.actions.updateCart(
            {
              note: this.note.value,
            },
            {
              context: 'cart',
              detail: {
                source: 'gift-wrap-note',
              },
            }
          );

          this.throwIfUserError(result);

          this.clearError();
        } catch (error) {
          this.showError(
            error instanceof Error
              ? error.message
              : 'Nota non salvata. Riprova.'
          );
        }
      }

      async clearCartNote() {
        const response = await fetch(
          `${window.Shopify.routes.root}cart/update.js`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              note: '',
            }),
          }
        );

        if (!response.ok) {
          throw new Error(
            'Impossibile rimuovere la nota regalo. Riprova.'
          );
        }
      }

      throwIfUserError(result) {
        if (result?.userErrors?.length) {
          throw new Error(result.userErrors[0].message);
        }
      }

      setBusy(isBusy) {
        this.toggle?.toggleAttribute('disabled', isBusy);

        this.toggle?.setAttribute(
          'aria-busy',
          String(isBusy)
        );
      }

      showError(message) {
        if (!this.error) return;

        this.error.textContent = message;
        this.error.removeAttribute('hidden');
      }

      clearError() {
        if (!this.error) return;

        this.error.textContent = '';
        this.error.setAttribute('hidden', '');
      }
    }
  );
}